import React from 'react'
import "./funds-transfer-pricing.scss"
import ValidTable from './valid-table'
import CreditSpreadTable from './credit-spread-table'
import CountryTable from './country-table'

const canData = [
  {
    id: 1,
    title: 'Today’s approximate interest rates',
    date: "05/31/2024",
    '0/n': "4.90%",
    '1m': "5.10",
    '3m': "4.80%",
    '6m': "4.20%",
    one: "4.20%",
    two: "3.90%",
    three: "3.70%",
    four: "3.70%",
    five: "3.70%",
    seven: "2.98%",
    ten: "2.90%",
  },
  {
    id: 2,
    title: 'Today’s Credit/Liquidity Spread',
    date: "05/31/2024",
    '0/n': "0.00%",
    '1m': "0.70%",
    '3m': "0.73%",
    '6m': "0.78%",
    one: "0.88%",
    two: "1.08%",
    three: "1.27%",
    four: "1.47%",
    five: "1.67%",
    seven: "2.06%",
    ten: "2.65%",
  },
  {
    id: 3,
    title: '',
    date: "",
    '0/n': "4.90%",
    '1m': "5.80%",
    '3m': "5.53%",
    '6m': "5.28%",
    one: "5.08%",
    two: "4.98%",
    three: "4.97%",
    four: "5.17%",
    five: "5.27%",
    seven: "5.04%",
    ten: "5.55%",
  },
];

const usdData = [
  {
    id: 1,
    title: 'Today’s approximate interest rates',
    date: "05/31/2024",
    '0/n': "4.50%",
    '1m': "4.68%",
    '3m': "4.76%",
    '6m': "4.84%",
    one: "5.18%",
    two: "4.48%",
    three: "4.10%",
    four: "3.72%",
    five: "3.81%",
    seven: "3.72%",
    ten: "3.70%",
  },
  {
    id: 2,
    title: 'Today’s Credit/Liquidity Spread',
    date: "05/31/2024",
    '0/n': "0.00%",
    '1m': "0.59%",
    '3m': "0.62%",
    '6m': "0.67%",
    one: "0.77%",
    two: "0.97%",
    three: "1.27%",
    four: "1.36%",
    five: "1.67%",
    seven: "1.95%",
    ten: "2.54%",
  },
  {
    id: 3,
    title: '',
    date: "",
    '0/n': "4.50%",
    '1m': "5.27%",
    '3m': "5.38%",
    '6m': "5.51%",
    one: "5.95%",
    two: "5.45%",
    three: "5.37%",
    four: "5.08%",
    five: "5.48%",
    seven: "5.67%",
    ten: "6.24%",
  },
];

const FundTransferPricing = () => {
  return (
    <div className='fund-transfer-pricing'>
      <div className='session-wrapper'>
        <ValidTable />
      </div>
      <div className='session-wrapper'>
        <CreditSpreadTable />
      </div>

      <div className='session-wrapper'>
        <CountryTable countryCode="can" data={canData} />
      </div>
      <div className='session-wrapper'>
        <CountryTable countryCode="usd" data={usdData} />
      </div>
    </div>
  )
}

export default FundTransferPricing